import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';
import CountUp from 'react-countup';


const Navbar = () => {
    const [activeClass, setActiveClass] = useState('/');

    let [open, setOpen] = useState(false);

    const [color, setColor] = useState(false)
    const changeColor = () => {
        if (window.scrollY >= 100) {
            setColor(true)
        }
        else {
            setColor(false)
        }
    }
    window.addEventListener('scroll', changeColor)

    const navMenu = [
        {
            name: "Home",
            link: '/',
            dname1: 'maya japanese',
            dname2: 'get coached',
            dname3: 'join me',
            dname4: 'news',
            dname5: 'social',
            dop1: '#maya',
            dop2: '#coach',
            dop3: '#join',
            dop4: '#news',
            dop5: '#social',
        },
        {
            name: "My Stories",
            link: '/stories',
            dname1: 'early life',
            dname2: 'education',
            dname3: 'certification',
            dname4: 'contribution',
            dname5: 'software professional',
            dname6: 'social media',
            dname7: 'join rk',
            dop1: '/stories',
            dop2: '/stories',
            dop3: '/stories',
            dop4: '/stories',
            dop5: '/stories',
            dop6: '/stories',
            dop7: '/stories',
        },
        {
            name: "Japanese Center",
            link: '/japanese',
            dname1: 'work in japan',
            dname2: 'immigrate to japan',
            dname3: 'study in japan',
            dname4: 'support in japan',
            dname5: 'explore in japan',
            dname6: 'free consultation',
            dop1: '/japanese',
            dop2: '/japanese',
            dop3: '/japanese',
            dop4: '/japanese',
            dop5: '/japanese',
            dop6: '/japanese'
        },
        {
            name: "Coaching",
            link: '/coach',
            dname1: 'life coaching',
            dname2: 'relationship counselings',
            dname3: 'grief support',
            dname4: 'goal settings',
            dname5: 'self development',
            dop1: '/coach',
            dop2: '/coach',
            dop3: '/coach',
            dop4: '/coach',
            dop5: '/coach'
        },
        {
            name: "Research",
            link: '/research',
            dname1: 'artificial intelligence',
            dname2: 'project management',
            dname3: 'conferenies',
            dname4: 'purlications',
            dname5: 'join a research',
            dop1: '/research',
            dop2: '/research',
            dop3: '/research',
            dop4: '/research',
            dop5: '/research'
        },
        {
            name: "contact",
            link: '/contact',
            dname1: 'join rk newsletter',
            dname2: 'free consultation',
            dname3: 'write rk',
            dop1: '/contact',
            dop2: '/contact',
            dop3: '/contact'
        },
        // {
        //     name: "Health",
        //     link: '/health',
        //     dname1: 'mental fitness',
        //     dname2: 'physical health',
        //     dname3: '21 days challenge',
        //     dname4: 'free fitness prousram',
        //     dop1: '/',
        //     dop2: '/',
        //     dop3: '/',
        //     dop4: '/'
        // }
    ]
    return (
        <div className=''>

            <div className='px-20 pt-10 hidden lg:block'>
                <div className='w-full flex justify-between items-center h-20 border-b-2 border-cyan-600'>
                    <div className=' flex items-center'>
                        <div className=" ml-2 mb-2 flex flex-col items-center justify-center font-['Playfair_Display'] text-3xl lg:text-2xl text-fifth font-bold">
                            RABINANDAN KISHOR <br /> <span className=' text-sm pl-44'>A synonym of struggle</span>
                        </div>
                    </div>
                    <div className=" ml-2 mb-2 flex flex-col items-center justify-center lg:text-xl text-base relative font-semibold text-cyan-800">
                        <span className="font-['Playfair_Display']">Except to bringing a smile to others  yours happiness must come first.</span>
                        <span className='flex xl:pl-96 ml-16 font-bold'><span className='mr-2'>A family of</span> <CountUp start={0} end={5000} delay={0}>
                            {({ countUpRef }) => (
                                <div>
                                    <span ref={countUpRef} />
                                </div>
                            )}
                        </CountUp>+</span>
                    </div>

                </div>

                <nav>
                    <div className={`${color ? 'fixed top-0 w-full left-0 bg-secondary text-white px-5' : 'text-slate-500'}`}>
                        <ul className={`flex justify-around py-2 font-['Work_Sans'] text-lg capitalize w-full`}>
                            {
                                navMenu.map((n, index) => <li key={index} className={`mx-2 py-1 px-3 font-semibold hover:text-white hover:cursor-pointer hover:bg-cyan-400 hover:rounded-md ease-in-out uppercase ${activeClass === n.link ? "bg-third text-white" : ""}`} onClick={() => setActiveClass(n.link)}>
                                    <div class="dropdown" >
                                        <Link to={n.link}>{n.name}</Link>
                                        <div class="dropdown-content">
                                            {n.dop1 && <a href={n.dop1}>{n?.dname1}</a>}
                                            {n.dop2 && <a href={n.dop2}>{n?.dname2}</a>}
                                            {n.dop3 && <a href={n.dop3}>{n?.dname3}</a>}
                                            {n.dop4 && <a href={n.dop4}>{n?.dname4}</a>}
                                            {n.dop5 && <a href={n.dop5}>{n?.dname5}</a>}
                                            {n.dop6 && <a href={n.dop6}>{n?.dname6}</a>}
                                            {n.dop7 && <a href={n.dop7}>{n?.dname7}</a>}
                                        </div>
                                    </div>
                                </li>)
                            }

                        </ul>

                    </div>
                </nav>

            </div>

            <div className={`flex justify-between items-center w-full pt-2 text-3xl px-2 cursor-pointer lg:hidden ${color ? 'fixed top-0 w-full left-0 bg-secondary text-white px-5' : ''}`}>
                <div className=" ml-2 mb-2 flex flex-col items-center justify-center font-['Playfair_Display'] md:text-2xl text-base lg:hidden text-blue-900 font-bold">
                    RABINANDAN KISHOR <br /> <span className=' text-sm md:pl-44'>A synonym of struggle</span>
                </div>
                {
                    !open ?
                        <Link onClick={() => setOpen(!open)} className='text-3xl px-2 cursor-pointer lg:hidden '><GiHamburgerMenu></GiHamburgerMenu></Link> :
                        <Link onClick={() => setOpen(!open)} className='text-xl px-2 cursor-pointer lg:hidden' ><ImCross className=' text-red-700' /></Link>
                }
            </div>

            {open === true &&
                <ul className={`transition-all duration-500 ease-in z-auto flex flex-col items-center  bg-slate-200 pt-2  font-['Work_Sans'] lg:hidden lg:text-base capitalize ${open === true && 'top-20'} top-[-490px] `}>
                    {
                        navMenu.map((n, index) => <li key={index} className={`mx-2 py-1 px-3 hover:text-white hover:cursor-pointer hover:bg-cyan-400 hover:rounded-md ease-in-out uppercase ${activeClass === n.link ? "text-cyan-400 " : ""}`} onClick={() => setActiveClass(n.link)}>
                            <div class="dropdown" >
                                <Link to={n.link}>{n.name}</Link>
                                <div class="dropdown-content">
                                    {n.dop1 && <a href={n.dop1}>{n?.dname1}</a>}
                                    {n.dop2 && <a href={n.dop2}>{n?.dname2}</a>}
                                    {n.dop3 && <a href={n.dop3}>{n?.dname3}</a>}
                                    {n.dop4 && <a href={n.dop4}>{n?.dname4}</a>}
                                    {n.dop5 && <a href={n.dop5}>{n?.dname5}</a>}
                                    {n.dop6 && <a href={n.dop6}>{n?.dname6}</a>}
                                    {n.dop7 && <a href={n.dop7}>{n?.dname7}</a>}
                                </div>
                            </div>
                        </li>)
                    }

                </ul>
            }



        </div>

    );
};

export default Navbar;